//Tooltip handler

export const init = (target) => {	
	//Close tooltip on click on the close button
	$(target).find('[data-function="dismiss-tooltip"]').unbind('click.dismiss-tooltip').bind('click.dismiss-tooltip', function(){				
		$(this).parents('.card').eq(0).addClass('d-none');
	});

	//Open / Close tooltip on click on the img
	$(target).find('[data-function="toggle-tooltip"]').unbind('click.toggle-tooltip').bind('click.toggle-tooltip', function(){
		$(this).next().toggleClass('d-none');
	});
}

//Change tooltip text
export const text = (target, text) => {	
	$(target).find('.card-body').html(text);
}

//Show tooltip btn
export const show = (target) => {	
	$(target).removeClass('d-none');	
}

//Show tooltip box
export const open = (target) => {	
	$(target).find('.card').removeClass('d-none');
}

//hide tooltip btn
export const hide = () => {	
	$(target).find('.card').addClass('d-none');
	$(target).addClass('d-none');
}